import { Theme } from '@mui/material/styles'

import { onHover, selectedState } from '../interaction'

// ----------------------------------------------------------------------

export default function Pagination(theme: Theme) {
  return {
    MuiPagination: {
      defaultProps: {
        color: 'standard' as const,
      },

      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            fontVariantNumeric: 'tabular-nums',
            ...onHover({ backgroundColor: theme.palette.action.hover }),
            // The current page is the kit's selected state, as in the nav and menus.
            '&.Mui-selected': {
              ...selectedState(theme),
              fontWeight: theme.typography.fontWeightMedium,
            },
          },
        },
      },
    },
  }
}
